document.addEventListener("DOMContentLoaded", () => {

    $(document).on('click', "#load-next", function() {
        let page = $(this).attr('data-paginate');
        loadMore(page);
    });
    
    $(document).on('click', "#load-previous", function() {
        let page = $(this).attr('data-paginate');
        loadMore(page);
    });
    
    function loadMore(pageUrl) {
        $.ajax({
            url: pageUrl,
            type: 'get',
            datatype: 'html',
            processData: false,
            contentType: false,
            success: function(data) {
                $('#listEvents').html(data);
                $('[eventPaginate]').removeAttr('data-animation');
            }
        })
        .fail(function(jqXHR, ajaxOptions, thrownError) {
            alert('Algo deu errado.');
        });
    }
})